import React from 'react';
import { AppShell } from '../components/AppShell';
import { SearchWidget } from '../components/SearchWidget';
export function BusquedasPage() {
  return <AppShell data-id="element-634">
      <SearchWidget mode="full" data-id="element-635" />
    </AppShell>;
}